/**
 * Kundenportal für Großunternehmen - Ummeldungs-API
 *
 * Contact: we.it.ikp-team@wienenergie.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Kunde } from './kunde.model';
import { Produktdaten } from './produktdaten.model';


export interface Ummeldung { 
    id?: string;
    status?: Ummeldung.StatusEnum;
    ummeldungTyp?: Ummeldung.UmmeldungTypEnum;
    produktdaten: Array<Produktdaten>;
    ummeldedatum?: string;
    bisherigerKunde?: Kunde;
    neuerKunde?: Kunde;
    aktuellerProzessSchritt?: Ummeldung.AktuellerProzessSchrittEnum;
}
export namespace Ummeldung {
    export const StatusEnum = {
        BEGONNEN: 'BEGONNEN',
        UEBERMITTELT: 'UEBERMITTELT',
        UNTERSCHRIFT_ERFORDERLICH: 'UNTERSCHRIFT_ERFORDERLICH',
        ABGESCHLOSSEN: 'ABGESCHLOSSEN'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
    export const UmmeldungTypEnum = {
        VON_LEERSTAND: 'VON_LEERSTAND',
        VON_BELEGT: 'VON_BELEGT'
    } as const;
    export type UmmeldungTypEnum = typeof UmmeldungTypEnum[keyof typeof UmmeldungTypEnum];
    export const AktuellerProzessSchrittEnum = {
        PRODUKT: 'PRODUKT',
        UMMELDEDATUM: 'UMMELDEDATUM',
        BISHERIGER_VERTRAGSPARTNER: 'BISHERIGER_VERTRAGSPARTNER',
        NEUER_VERTRAGSPARTNER: 'NEUER_VERTRAGSPARTNER',
        ZUSAMMENFASSUNG: 'ZUSAMMENFASSUNG',
        BESTAETIGUNG: 'BESTAETIGUNG'
    } as const;
    export type AktuellerProzessSchrittEnum = typeof AktuellerProzessSchrittEnum[keyof typeof AktuellerProzessSchrittEnum];
}


